import {
    useSelector,
    TypedUseSelectorHook
} from "react-redux";

import {
    ApplicationStateType
} from "@Store";


export const useTypedSelector: TypedUseSelectorHook<ApplicationStateType> = useSelector;


export default useTypedSelector;
